export function useInlineImageLoader(downloadAttachment) {
    async function blobUrlFor(attachmentId, messageId, contentType) {
        const blob = await downloadAttachment(attachmentId, messageId)
        const type = contentType || 'application/octet-stream'
        return URL.createObjectURL(new Blob([blob], { type }))
    }

    async function loadCidImages(cidPlaceholders = [], messageId) {
        const tasks = cidPlaceholders.map(async ({ attachment, dataUrl }) => {
            const url = await blobUrlFor(attachment.id, messageId, attachment.content_type)
            const imgs = Array.from(document.querySelectorAll('img')).filter((img) => img.src === dataUrl)

            if (imgs.length > 0) {
                imgs.forEach((img, idx) => {
                    img.onload = () => {
                        if (idx === imgs.length - 1) {
                            URL.revokeObjectURL(url)
                        }
                    }
                    img.onerror = () => {
                        URL.revokeObjectURL(url)
                    }
                    img.src = url
                })
            } else {
                URL.revokeObjectURL(url)
            }
        })

        await Promise.allSettled(tasks)
    }

    async function loadInlineImages(inlinePlaceholders = [], messageId) {
        const tasks = inlinePlaceholders.map(async ({ id, attachment }) => {
            const el = document.getElementById(id)

            if (!el) {
                return
            }

            const url = await blobUrlFor(attachment.id, messageId, attachment.content_type)
            el.innerHTML = `<img src="${url}" alt="${attachment.filename || 'Image'}" style="max-width:100%;height:auto;border-radius:8px;" />`
            const img = el.querySelector('img')

            if (img) {
                img.onload = () => {
                    URL.revokeObjectURL(url)
                }

                img.onerror = () => {
                    URL.revokeObjectURL(url)
                }
            } else {
                URL.revokeObjectURL(url)
            }
        })

        await Promise.allSettled(tasks)
    }

    return { loadCidImages, loadInlineImages }
}
